<template>
  <header>
    <div class="icon-container">
      <router-link to="/" class="icon-wrapper" title="Home">
        <img class="social-icon" src="../assets/Header/home (4).png" alt="Home" />
        <span class="tooltip">Home</span>
      </router-link>

      <router-link to="/projects" class="icon-wrapper" title="Projects">
        <img class="social-icon" src="../assets/Header/connection.png" alt="Projects" />
        <span class="tooltip">Projects</span>
      </router-link>

      <router-link to="/tech-stack" class="icon-wrapper" title="Tech Stack">
        <img class="social-icon" src="../assets/Header/layers.png" alt="Tech Stack" />
        <span class="tooltip">Tech Stack</span>
      </router-link>

      <router-link to="/contact" class="icon-wrapper" title="Contact">
        <img class="social-icon" src="../assets/Header/customer-service.png" alt="Contact" />
        <span class="tooltip">Contact</span>
      </router-link>
    </div>
  </header>
</template>

<script>
export default {
  name: 'PageHeader',
}
</script>

<style scoped>
header {
  background-color: transparent;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: sticky;
  top: 45px;
  left: 0;
  right: 0;
  z-index: 40;
  box-sizing: border-box;
}

.icon-container {
  display: flex;
  gap: 20px;
  padding: 10px 20px;
  background-color: #1f1f1f;
  border-radius: 14px;
}

.icon-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
}

.social-icon {
  height: 20px;
  width: 20px;
  filter: brightness(0) invert(1);
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}

.social-icon:hover {
  filter: drop-shadow(0 0 5px #ffffff) brightness(0) invert(1);
  transform: scale(1.2);
}

/* Tooltip */
.tooltip {
  position: absolute;
  bottom: 130%;
  background-color: rgba(0, 0, 0, 0.75);
  color: #fff;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 10px;
  white-space: nowrap;
  opacity: 0;
  transform: translateY(10px);
  transition: all 0.2s ease-in-out;
  pointer-events: none;
}

.icon-wrapper:hover .tooltip {
  opacity: 1;
  transform: translateY(0);
}

/* Mobile Optimization */
@media screen and (max-width: 767px) {
  .icon-container {
    gap: 15px;
    padding: 8px 16px;
  }

  .social-icon {
    height: 18px;
    width: 18px;
  }
}
</style>
